import { stringifySetCookie } from "cookie";
const sessionOpts = {
    httpOnly: true,
    // default to secure in production, but allow override for testing:
    secure: process.env.NODE_ENV === "production" &&
        process.env.SESSION_COOKIE_FORCE_INSECURE !== "true" &&
        process.env.SESSION_COOKIE_FORCE_INSECURE !== "1",
    sameSite: "strict",
    path: "/",
    maxAge: process.env.SESSION_TTL_SECONDS ? Number(process.env.SESSION_TTL_SECONDS) : 60 * 60 * 3, // 3 hours
};
//TODO: describe interface?
export const makeCookieSessionStorage = (req, res) => {
    const cookieName = "st";
    return {
        store: (data) => {
            res.setHeader("Set-Cookie", stringifySetCookie(cookieName, data, sessionOpts));
        },
        load: () => {
            return req.cookies[cookieName];
        },
    };
};
